import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { DetailInfoListComponent } from './detail-info-list.component';
import { DetailInfoTypeModule } from 'shared/detail-info-type/detail-info-type.module';


@NgModule({
  declarations: [
    DetailInfoListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    DetailInfoTypeModule
  ],
  exports: [DetailInfoListComponent],
})
export class DetailInfoListModule { }
